import { SCView } from '@lib/sc-eone-ui';
import { Tooltip } from 'eone-ui/tooltip/tooltip';

interface SCFormLabelProps {
  label?: string;
  required?: boolean;
  actionButtons?: React.ReactNode;
  Tooltip?: { Message: string };
}

function SCFormLabel({ label, required, actionButtons, Tooltip: tooltipProps }: SCFormLabelProps) {
  return (
    <SCView flex flexRow justifyBetween textNormal mb={2}>
      <SCView className="eone-ui-form-label">
        {label}
        {required && <span>*</span>}
        {tooltipProps && <Tooltip Title={label} Tooltip={tooltipProps} />}
      </SCView>
      {actionButtons}
    </SCView>
  );
}

export { SCFormLabel };
export type { SCFormLabelProps };

import React, { Children } from 'react';
import './forms.css';

function FormColumn(props) {
  const getWidth = () => {
    const columnWidth = props.ColumnWidths[props.ColumnNumber % props.ColumnWidths.length];
    const totalWidth = props.ColumnWidths.reduce((a, b) => a + b, 0);
    const percentageWidth = (100 * columnWidth) / totalWidth;
    const margin = props.Margin || 12;
    const marginOffset = (margin * (props.ColumnWidths.length - 1)) / props.ColumnWidths.length;
    return `calc(${percentageWidth}% - ${marginOffset}px)`;
  };

  const getMargin = () => {
    if (props.ColumnNumber % props.ColumnWidths.length === 0) return 0;
    return props.Margin || 12;
  };

  const getStyle = () => {
    return {
      width: getWidth(),
      marginLeft: getMargin(),
    };
  };

  if (props.Skeleton) {
    return (
      <div className="eone-ui-form-column" style={getStyle()}>
        {React.cloneElement(props.Column, { Skeleton: true })}
      </div>
    );
  }

  return (
    <div className="eone-ui-form-column" style={getStyle()}>
      {props.Column}
    </div>
  );
}

function SCFormColumns(props) {
  const getColumnWidths = () => {
    if (props.ColumnWidths) return props.ColumnWidths;
    if (props.Columns) return Array(props.Columns).fill(1);
    return [1];
  };

  const getColumns = () => {
    const columnWidths = getColumnWidths();
    const columns = Children.toArray(props.children);
    return columns.map((column, index) => {
      return (
        <FormColumn
          key={index}
          ColumnNumber={index}
          ColumnWidths={columnWidths}
          Column={column}
          Skeleton={props.Skeleton}
          Animate={props.Animate}
        />
      );
    });
  };

  if (props.Visible !== undefined && !props.Visible) {
    return null;
  }

  return <div className="eone-ui-form-columns">{getColumns()}</div>;
}

export { SCFormColumns };
